<template>
    <span
        :class="[
            bgColor ? '' : 'c-tag--' + color,
            'c-tag--' + type,
            'c-tag',
            hoverColor ? 'c-tag-hover--' + hoverColor : ''
        ]"
        :style="[
            { 'background-color': bgColor },
            type === 'circle'
                ? {
                      width: size + 'px',
                      height: size + 'px',
                      'line-height': size + 'px'
                  }
                : ''
        ]"
    >
        <slot></slot>
    </span>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'round',
            validator: (val) => {
                return ['round', 'circle', 'half-round', 'half-round-reserve'].includes(val);
            }
        },
        color: {
            type: String,
            default: 'brown',
            validator: (val) => {
                return ['brown', 'green', 'orange'].includes(val);
            }
        },
        hoverColor: {
            type: String,
            validator: (val) => {
                return ['brown', 'green', 'orange'].includes(val);
            }
        },
        size: {
            type: Number,
            default: 30
        },
        bgColor: {
            type: String
        }
    }
};
</script>

<style lang="scss">
.c-tag {
    display: inline-block;
    padding: 11px 17px;
    font-size: 20px;
    color: #ffffff;
    border-radius: 4;
    text-align: center;
    &--half-round {
        border-radius: 20px 0px 20px 0px;
    }
    &--half-round-reserve {
        border-radius: 0px 20px 0px 20px;
    }
    &--round {
        border-radius: 2000px;
    }
    &--circle {
        padding: 0;
        border-radius: 50%;
        box-sizing: border-box;
    }
    &--brown {
        background: linear-gradient(168deg, #ecb96b, #bd8836);
    }
    &-hover--brown {
        &:hover {
            background: linear-gradient(168deg, #ecb96b, #bd8836);
        }
    }
    &--green {
        background: linear-gradient(-84deg, #33ba86, #0aa66a);
    }
    &-hover--green {
        &:hover {
            background: linear-gradient(-84deg, #33ba86, #0aa66a);
        }
    }
    &--orange {
        background: linear-gradient(-71deg, #ef771f, #f6a94d);
    }
    &-hover--orange {
        &:hover {
            background: linear-gradient(-71deg, #ef771f, #f6a94d);
        }
    }
    & + & {
        margin-left: 5px;
    }
}
</style>
